import ArticleCard from "@/components/feature/ArticleCard";
import SectionTitle from "@/components/feature/SectionTitle";
import { articles } from "@/mocks/articles";
import type { Article } from "@/types/content";

const LatestSection = () => {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  const latest = sorted.slice(0, 6) as Article[];

  return (
    <section className="bg-background-50 paper-grain">
      <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          eyebrow="最新翻出"
          title="刚刚整理完的条目"
          desc="按整理完成时间排列，越靠前越新。"
          linkTo="/archive"
          linkLabel="更多条目"
        />
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestSection;